import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PaymentResult from "../../components/PaymentResult/PaymentResult";
import { handlePaymentFailure, notifyCustomerOfPaymentFailure } from "../../services/Storeapi";

function PaymentFailure() {
    const { state } = useLocation();
    const [searchParams] = useSearchParams();
    const [customerInfo, setCustomerInfo] = useState(null);
    const [error, setError] = useState(state?.error || "");
    const [notifyMessage, setNotifyMessage] = useState("");

    const hashedAppointmentID = state?.hashedAppointmentID ?? state?.hashed_appointment_id ?? searchParams.get("hashed_appointment_id") ?? "Unknown";
    const token = state?.token ?? searchParams.get("token") ?? "";

    useEffect(() => {
        if (!hashedAppointmentID || hashedAppointmentID === "Unknown") {
            return;
        }

        handlePaymentFailure(hashedAppointmentID, token)
            .then((response) => {
                const normalizedCustomer = response?.customer_info ?? {
                    id: response?.customer_id ?? null,
                    email: response?.customer_email ?? null,
                    phone: response?.customer_phone ?? null,
                    first_name: response?.customer_first_name ?? null,
                    last_name: response?.customer_last_name ?? null,
                };

                setCustomerInfo(normalizedCustomer);
                setError("");
            })
            .catch((fetchError) => {
                console.error("Payment failure handling failed:", fetchError);
                setError(fetchError?.message || "Payment failure handling failed.");
            });
    }, [hashedAppointmentID, token]);

    const appointmentForDisplay = state?.appointment ?? (customerInfo ? { customer_info: customerInfo } : null);

    const handleNotifyCustomer = async () => {
        if (!customerInfo?.id) {
            setNotifyMessage("Customer ID is not available yet.");
            return;
        }

        try {
            await notifyCustomerOfPaymentFailure(customerInfo.id, token);
            setNotifyMessage("Customer notification sent.");
        } catch (notifyError) {
            console.error("Failed to notify customer of payment failure:", notifyError);
            setNotifyMessage(notifyError?.message || "Failed to notify customer of payment failure.");
        }
    };

    return (
        <PaymentResult
            tone="failure"
            title="Confirmation Needs Attention"
            message="Confirmation could not be completed. A payment may still be processing; check its status before taking further payment action."
            errorMessage={error || state?.error}
            appointment={appointmentForDisplay}
            customerInfo={customerInfo}
            onNotifyCustomer={customerInfo?.id ? handleNotifyCustomer : null}
            notifyMessage={notifyMessage}
            showRetry
        />
    );
}

export default PaymentFailure;